<template>
	<v-app>
		<router-view></router-view>
		<v-snackbar :timeout="snackbar.timeout" :color="snackbar.color"
			:top="true" :right="true" v-model="snackbar.isVisible">
			{{ snackbar.text }}
			<v-btn flat @click.native="snackbar.isVisible = false">Cerrar</v-btn>
		</v-snackbar>
	</v-app>
</template>

<script>
function snackbar() {
	return this.$store.getters.snackbar;
}

export default {
	name: 'app',
	computed: {
		snackbar,
	},
};
</script>

<style lang="scss">
html {
	font-size: 16px;
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
	-webkit-appearance: none;
	margin: 0;
}

.content {
	background: white;
	padding: 133px 12px 0px !important;

	&--wrap {
		background-color: lighten(map-get($colors, grey), 0.15);
		padding: 0px 12px;
	}

	@media (min-width: 768px) {
		padding: 80px 0px 0px !important;
	}
}

.chk-all {
	&.input-group {
		.input-group__input {
			.icon {
				font-size: 18px !important;
				height: 18px;
			}
		}
		.input-group__details {
			display: none;
		}
	}
}

.bars-align {
	background-color: map-get($colors, blue-grey);

	.list__tile {
		justify-content: flex-end;
		padding-left: 2px;

		&--avatar {
			height: 40px;
		}
	}

	.btn {
		color: map-get($colors, base);
	}
}

.sidebar-bg {
	&.list {
		.list__group {
			&__header {
				&__prepend-icon,
				&__append-icon {
					display: none;
				}

				&:hover {
					background: transparent;
				}

				.list__tile {
					font-family: map-get($fonts, open-semibold);
					font-size: 18px;
					opacity: 0.5;
					padding: 0 16px 0 26px;

					&:hover,
					&--active {
						background: transparent;
						opacity: 1;
					}
				}

				&--active {
					.list__tile {
						opacity: 1;
					}
				}
			}

			&__items {
				&.padding-items {
					padding-bottom: 12px;
				}

				.list__tile {
					font-size: 13px;
					height: 28px;
					opacity: 0.5;
					padding-left: 16px;

					&:hover,
					&--active {
						background: transparent;
						opacity: 1;
					}

					&__action {
						justify-content: flex-start;
						min-width: 26px;

						.icon {
							font-size: 6px;
						}
					}
				}
			}

			&:before,
			&:after {
				background: rgba(0, 0, 0, 0.12);
			}
		}
	}
}

.sidebar-border {
	.navigation-drawer__border {
		background-color: map-get($colors, base) !important;
		width: 3px;
	}

	&.navigation-drawer--mini-variant {
		.list__group__header {
			.list__tile {
				padding-left: 0px;

				&__content {
					display: none;
				}
			}
		}
	}
}

.columns-menu {
	&.menu__content {
		background-color: white;
		border-radius: 4px;
		box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.4);
		max-width: 154px;
		padding-left: 5px;
		padding-right: 5px;

		.input-group {
			label {
				color: map-get($colors, black);
				font-family: map-get($fonts, opens-semibold);
				font-size: 13px;
			}

			&__input {
				min-height: 20px;

				.icon {
					font-size: map-get($sizes, medium);
					height: 5px !important;
				}
			}

			&--selection-controls__ripple {
				height: 10px;
				transform: translate(2px, 0%);
				width: 10px;
			}
		}

		.apply {
			border-top: 1px solid #e5e5e5;
			margin-top: 5px;

			button {
				color: map-get($colors, info);
				font-family: map-get($fonts, opens-semibold);
				font-size: 13px;
				outline: none;
			}
		}
	}
}

.header-page-download-document {
	.btn__content {
		padding: 0px;
	}
}

.modal-filter-footer {
	background-color: white;
	bottom: 0%;
	left: 0px;
	position: fixed;
	right: 0px;
	width: 100%;
	z-index: 2;
}

.btn-action {
	border-radius: 5px !important;
	box-shadow: none !important;
	color: white !important;
	height: 30px !important;
	margin: 0px;
	text-transform: none !important;
	width: 97px !important;

	.btn__content {
		font-family: map-get($fonts, open-semibold);
		font-size: map-get($sizes, small10);
		padding: 0px;

		img {
			height: 20px;
			margin-left: 10px;
		}
	}

	&.text-large {
		.btn__content {
			font-family: map-get($fonts, open-bold);
			font-size: map-get($sizes, small);
		}
	}
}

.notification {
	&-btn {
		.btn__content {
			padding: 0px;
		}
	}

	&-card {
		.btn__content {
			max-width: 100%;
			padding: 0px 0px 0px 17%;
			white-space: normal;
		}
	}
}

.theme--light {
	color: map-get($colors, black) !important;

	.table-icon {
		.btn__content {
			padding: 0px;
		}

		&.btn--disabled {
			&:not(.btn--icon):not(.btn--flat) {
				background-color: transparent !important;
				opacity: 0.6;
			}
		}
	}
}

button {
	min-width: 5px;
	outline: none;

	.table-icon {
		outline: none;
	}
}

#calendar {
	padding: 0px 15px 15px;

	.fc {
		&-toolbar {
			&.fc-header-toolbar {
				margin-bottom: 0px;
			}
		}

		&-button {
			background-color: map-get($colors, background-sidebar);
			background-image: none;
			border: 1px solid map-get($colors, black);
			box-shadow: none;
			color: map-get($colors, black);
			font-family: map-get($fonts, open-regular);
			font-size: map-get($sizes, medium);
			height: 25px;
			line-height: map-get($sizes, medium);
			outline: none;
			text-shadow: none;

			&:first-child {
				border-bottom-left-radius: 5px;
				border-top-left-radius: 5px;
			}

			&:last-child {
				border-bottom-right-radius: 5px;
				border-top-right-radius: 5px;
			}
		}

		&-center {
			h2 {
				color: map-get($colors, black);
				font-family: map-get($fonts, regular);
				font-size: map-get($sizes, medium18);
			}
		}
	}
}

.title-form {
	color: map-get($colors, paginationText);
	font-family: map-get($fonts, open-semibold);
	font-size: 13px;
}

.form-group__message {
	color: map-get($colors, orange-btn);
	font-family: map-get($fonts, open-semibold);
	font-size: 11px;
}

.btn-list {
	border-radius: 5px !important;
	box-shadow: none !important;
	height: 20px !important;
	min-width: 20px !important;

	&-add {
		border: 1px solid map-get($colors, primary);
		color: map-get($colors, primary) !important;
	}

	&-remove {
		border: 1px solid map-get($colors, orange-btn);
		color: map-get($colors, orange-btn) !important;
	}

	.btn__content {
		height: 18px;
		padding: 0px;
	}

	.icon {
		font-size: 20px;
	}
}

@-moz-keyframes loader {
	from {
		transform: rotate(0);
	}
	to {
		transform: rotate(360deg);
	}
}

@-webkit-keyframes loader {
	from {
		transform: rotate(0);
	}
	to {
		transform: rotate(360deg);
	}
}

@-o-keyframes loader {
	from {
		transform: rotate(0);
	}
	to {
		transform: rotate(360deg);
	}
}

@keyframes loader {
	from {
		transform: rotate(0);
	}
	to {
		transform: rotate(360deg);
	}
}

.size {
	cursor: pointer;
	height: 30px;
	width: 30px;
}

.expansion-panel-component {
	.expansion-panel {
		&__header {
			background-color: map-get($map: $colors, $key: expansion-panel-header);
			color: white;
			font-family: map-get($map: $fonts, $key: open-semibold);
			font-size: 13px;
			height: 30px;
			line-height: 1.2;
			padding: 0px 0px 0px 34px;
			text-transform: capitalize;
		}

		&__container .header__icon {
			border-left: 1px solid white;
			height: 30px;
		}

		&__container .header__icon .icon {
			color: white !important;
			font-size: 44px;
			height: 30px;
			line-height: 0.7;
		}
	}
}

.row-background-grey {
	background-color: map-get($map: $colors, $key: background-table);
}

.feature-footer {
	background-color: white;
	bottom: 0;
	position: absolute;
	width: 100%;
}

.input-group--error {
	border: 1px solid !important;
	box-shadow: none !important;
}

.input-group.input-group--selection-controls .input-group__input .icon--selection-control {
	line-height: 30px;
}

.filter-columns.input-group.input-group--selection-controls .input-group__input .icon--selection-control {
	line-height: normal;
}

.input-small {
	width: 100px !important;

	.v-input__control {
		min-height: auto !important;
	}
}

.buttons-footer {
	bottom: 0%;
	left: 0px;
	position: fixed;
	right: 0px;
	width: 100%;
	z-index: 2;
}

.table-padding {
	padding-bottom: 100px;
}

.expansion-panel-modules {
	.v-expansion-panel__header {
		padding: 0px 24px;
	}

	.v-input {
		margin-top: 0px;
		padding: 0px;
	}

	.v-label {
		height: 100% !important;
		width: 100%;
	}
}

.expansion-panel-template {
	box-shadow: none !important;
}

.flex-style {
	display: flex;
}
.align-items-center {
	align-items: center;
}

.flex-start {
	justify-content: flex-start;
}

.space-between {
	justify-content: space-between;
}

.flex-wrap {
	flex-wrap: wrap;
}

.flex-auto {
	flex: 1 1 auto;
}

.active-module-class {
	background-color: map-get($colors, green-icon) !important;
	color: white;

	.success--text {
		color: white !important;
	}
}

.content-tabs-configuration {
	position: relative;
	z-index: 2;

	.v-tabs__item {
		border: 1px solid #1A4338;
		color: #1A4338;
		height: 26px;
	}

	.v-tabs__container {
		background-color: #fafafa;
	}

	.v-card__text {
		background-color: #fafafa;
		padding: 5px;
	}

	.v-tabs {
		display: flex;
		justify-content: flex-start;
	}

	.v-tabs__item--active {
		background-color: #1A4338;
		color: white !important;
	}

	.accent {
		display: none;
	}
}

.dealers-projects {
	.v-tabs__wrapper {
		border-bottom: 5px solid map-get($colors, bgGreyHover);
	}

	.v-tabs__div {
		font-size: 12px;
	}

	.v-tabs__item--active {
		color: map-get($colors, base);
	}
}

.page-implementers-company {
	.v-tabs__item {
		border: none;
	}

	.v-tabs__item--active {
		background-color: none;
	}

	.v-tabs {
		background-color: white;
		justify-content: flex-end;
	}
	
	.v-tabs__div {
		background-color: white;
	}

	.v-tabs__item--active {
		background-color: white !important;
		border-bottom: 5px solid #1A4338;
		color: #1A4338 !important;
	}

	.v-tabs__item {
		color: #b9c9ce;
		padding-bottom: 14px;
	}
}

.dealers-projects {
	.v-tabs__wrapper {
		border-bottom: 5px solid map-get($colors, bgGreyHover);
	}

	.v-tabs__div {
		font-size: 12px;
	}

	.v-tabs__item--active {
		color: map-get($colors, base);
	}
}

.page-dealers-resource {
	.v-tabs__div {
		font-size: 12px;
	}
	
	.v-tabs__item--active {
		color: map-get($colors, base);
	}

	.v-tabs__slider {
		border-bottom: 5px solid map-get($colors, base);
	}
}

.page-dealers-application {
	.v-tabs__item--active {
		color: map-get($colors, tab);
		font-family: map-get($fonts, bold);
		font-size: map-get($sizes, small);
	}
	
	.v-tabs__slider {
		border-bottom: 5px solid map-get($colors, bgGreyHover);
	}

	.v-tabs__div {
		font-size: map-get($sizes, small);
	}
}

.theme--dark .v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat), .application .theme--dark.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat) {
  background-color: rgba(0,0,0,0.12) !important;
}

/* Selectores globales: apariencia consistente para formularios y filtros. */
.application .v-select.v-text-field--solo .v-input__slot,
.application .v-select.v-text-field--box .v-input__slot {
	background: #fff !important;
	border: 1px solid #d6e2ed;
	border-radius: 10px !important;
	box-shadow: 0 2px 8px rgba(34, 66, 96, 0.07) !important;
	min-height: 44px;
	transition: border-color 0.16s ease, box-shadow 0.16s ease, background 0.16s ease;
}

.application .v-select.v-text-field--box .v-input__slot::before,
.application .v-select.v-text-field--box .v-input__slot::after {
	display: none !important;
}

.application .v-select.v-input--is-focused .v-input__slot {
	border-color: #2E6B59 !important;
	box-shadow: 0 0 0 3px rgba(46, 107, 89, .14) !important;
}

.application .v-select.v-input--has-state.error--text .v-input__slot {
	border-color: #ef6674 !important;
	box-shadow: 0 0 0 3px rgba(239, 102, 116, 0.1) !important;
}

.application .v-select .v-select__selection {
	color: #314a61;
	font-size: 13px;
	font-weight: 500;
	line-height: 1.35;
}

.application .v-select .v-label {
	color: #718497;
	font-size: 13px;
}

.application .v-select.v-input--is-focused .v-label,
.application .v-select.v-input--is-dirty .v-label {
	color: #1A4338;
}

.application .v-select .v-input__append-inner {
	align-self: center;
	margin-top: 0;
}

.application .v-select .v-input__append-inner .v-icon {
	color: #6f8497;
	font-size: 21px;
	transition: color 0.16s ease, transform 0.16s ease;
}

.application .v-select.v-input--is-focused .v-input__append-inner .v-icon {
	color: #1A4338;
	transform: rotate(180deg);
}

.application .v-select.v-input--is-disabled .v-input__slot {
	background: #f1f4f7 !important;
	border-color: #e0e6ec;
	box-shadow: none !important;
	opacity: 0.78;
}

.application .v-select .v-chip {
	background: #EAF3EF !important;
	border: 1px solid #c5def3;
	border-radius: 7px;
	color: #1A4338;
	font-size: 11px;
	font-weight: 600;
	height: 26px;
}

.application .v-menu__content {
	border: 1px solid #dbe5ee;
	border-radius: 10px;
	box-shadow: 0 12px 30px rgba(29, 52, 74, 0.16) !important;
}

.application .v-menu__content .v-select-list {
	background: #fff;
	padding: 6px;
}

.application .v-menu__content .v-select-list .v-list__tile {
	border-radius: 7px;
	color: #40586d;
	font-size: 13px;
	min-height: 38px;
	transition: background 0.14s ease, color 0.14s ease;
}

.application .v-menu__content .v-select-list .v-list__tile:hover {
	background: #EEF5F2;
	color: #1A4338;
}

.application .v-menu__content .v-select-list .v-list__tile--active {
	background: #EAF3EF;
	color: #1A4338;
	font-weight: 600;
}

/* Global premium form system. */
.application .v-form {
	color: #314a61;
}

.application .v-form .v-text-field:not(.v-select) .v-input__slot,
.application .v-form .v-textarea .v-input__slot {
	background: #f8fafc !important;
	border: 1px solid #d7e1ea !important;
	border-radius: 8px !important;
	box-shadow: none !important;
	margin-bottom: 2px;
	min-height: 44px;
	transition: background .16s ease, border-color .16s ease, box-shadow .16s ease;
}

.application .v-form .v-text-field:not(.v-select) .v-input__slot::before,
.application .v-form .v-text-field:not(.v-select) .v-input__slot::after,
.application .v-form .v-textarea .v-input__slot::before,
.application .v-form .v-textarea .v-input__slot::after {
	display: none !important;
}

.application .v-form .v-text-field:not(.v-select).v-input--is-focused .v-input__slot,
.application .v-form .v-textarea.v-input--is-focused .v-input__slot {
	background: white !important;
	border-color: #2E6B59 !important;
	box-shadow: 0 0 0 3px rgba(46, 107, 89, .12) !important;
}

.application .v-form .v-input--has-state.error--text .v-input__slot {
	background: #fffafa !important;
	border-color: #e45d68 !important;
	box-shadow: 0 0 0 3px rgba(228, 93, 104, .08) !important;
}

.application .v-form .v-text-field input,
.application .v-form .v-textarea textarea {
	color: #29445b;
	font-size: 13px;
	line-height: 1.45;
}

.application .v-form .v-textarea textarea {
	min-height: 82px;
	padding-top: 9px;
}

.application .v-form .v-label {
	color: #6f8395;
	font-size: 12px;
}

.application .v-form .v-input--is-focused .v-label {
	color: #1A4338;
}

.application .v-form .v-messages {
	font-size: 10px;
	min-height: 14px;
}

.application .v-form .v-input--selection-controls {
	margin-top: 5px;
	padding-top: 0;
}

.application .v-form .v-input--selection-controls .v-label {
	color: #405970;
	font-size: 12px;
}

.application .v-form .v-input--selection-controls .v-icon {
	color: #7890a3;
	font-size: 21px;
}

.application .v-form .v-input--selection-controls.v-input--is-label-active .v-icon {
	color: #1A4338;
}

.application .v-form .v-input--switch .v-input--selection-controls__ripple {
	transform: scale(.82);
}

.application .v-form .v-input--is-disabled .v-input__slot {
	background: #f0f3f6 !important;
	border-color: #e1e7ec !important;
	opacity: .82;
}

.application .v-form .title-form,
.application .v-form h3 {
	color: #29455d;
	font-family: map-get($fonts, opens-semibold);
	font-size: 13px;
	letter-spacing: .01em;
}

.application .v-dialog {
	border-radius: 14px;
	box-shadow: 0 22px 55px rgba(23, 44, 65, .22);
	overflow: hidden;
}

.application .v-dialog .v-card {
	border-radius: 14px;
}

.application .v-dialog .v-card__text {
	color: #405970;
	font-size: 13px;
	line-height: 1.55;
	padding: 22px 24px;
}

/* Keep legacy Vuetify blue helpers inside the application brand palette. */
.application .blue,
.application .light-blue,
.application .info {
	background-color: #1A4338 !important;
	border-color: #1A4338 !important;
}

.application .blue--text,
.application .light-blue--text,
.application .primary--text,
.application .info--text {
	color: #1A4338 !important;
	caret-color: #1A4338 !important;
}

.application .v-btn.primary:hover,
.application .v-btn.blue:hover,
.application .v-btn.info:hover,
.application .btn-primary:hover {
	background-color: #2E6B59 !important;
	border-color: #2E6B59 !important;
}

.application .v-btn.primary:focus,
.application .v-btn.blue:focus,
.application .v-btn.info:focus {
	box-shadow: 0 0 0 3px rgba(46, 107, 89, .22) !important;
}

.application .v-data-table tbody tr:hover:not(.v-data-table__empty-wrapper),
.application table tbody tr:hover {
	background: #EEF5F2 !important;
}

.application .v-data-table tbody tr.v-table__active,
.application table tbody tr.is-selected,
.application table tbody tr.selected-row {
	background: #E2EFE9 !important;
}

@media (max-width: 700px) {
	.application .v-form .v-text-field:not(.v-select) .v-input__slot { min-height: 42px; }
	.application .v-dialog { margin: 12px; max-width: calc(100vw - 24px) !important; }
}
</style>



// WEBPACK FOOTER //
// src/App.vue